"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBraintreeApiKey = exports.getPaymentNonce = exports.deleteBraintreeCreditCard = exports.saveBraintreeCreditCard = void 0;
var axios_1 = __importDefault(require("axios"));
require("rxjs");
var rxjs_1 = require("rxjs");
var storage_1 = require("../../utils/storage");
var operators_1 = require("rxjs/operators");
/**
 * GLOBAL VARS
 **/
var braintree = require('braintree-web');
/**
 * SAVE CREDIT CARD ON BRAINTREE
**/
function saveBraintreeCreditCard(card, config) {
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var customertoken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var BRAINTREE_PAYMENTS_URL = "https://card-payments" + appEnvironment + ".cargosprintgroup.com/braintree";
    return getPaymentNonce(card, { token: customertoken, environment: appEnvironment })
        .pipe(operators_1.switchMap(function (nonceResponse) {
        return rxjs_1.from(axios_1.default({
            method: 'POST',
            url: BRAINTREE_PAYMENTS_URL + '/savePaymentMethod',
            data: { saveNonce: nonceResponse.creditCards[0].nonce },
            headers: { Authorization: "Bearer " + customertoken },
        }));
    }));
}
exports.saveBraintreeCreditCard = saveBraintreeCreditCard;
function deleteBraintreeCreditCard(card, config) {
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var token = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var BRAINTREE_PAYMENTS_URL = "https://card-payments" + appEnvironment + ".cargosprintgroup.com/braintree";
    return rxjs_1.from(axios_1.default({
        method: 'DELETE',
        url: BRAINTREE_PAYMENTS_URL + "/deletePaymentMethod/" + card.token,
        data: {},
        headers: { Authorization: "Bearer " + token }
    }));
}
exports.deleteBraintreeCreditCard = deleteBraintreeCreditCard;
/**
 *
 * BRAINTREE UTILITIES
 *
**/
/**
 * GETTING PAY NONCE FOR BRAINTREE
 * @param token
 * @param card
 **/
function getPaymentNonce(card, config) {
    var environment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var customertoken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var appConfig = {
        token: customertoken,
        environment: environment
    };
    return new rxjs_1.Observable(function (observer) {
        getBraintreeApiKey(appConfig).subscribe(function (apiKey) {
            braintree.client.create({
                authorization: apiKey.clientToken
            }).then(function (client) {
                client.request({
                    endpoint: 'payment_methods/credit_cards',
                    method: 'post',
                    data: {
                        creditCard: {
                            cardholderName: card.holderName,
                            number: card.number,
                            expirationDate: card.month + '/' + card.year,
                            cvv: card.cvv,
                            billingAddress: {
                                firstName: card.holderName.split(' ')[0],
                                lastName: card.holderName.split(' ')[1],
                                postalCode: card.billingAddress.postalCode,
                                streetAddress: card.billingAddress.streetAddress,
                                locality: card.billingAddress.state,
                                region: card.billingAddress.city,
                                countryName: card.billingAddress.countryName,
                            },
                        },
                    },
                }).then(function (payNonce) {
                    observer.next(payNonce);
                    observer.complete();
                }).catch(function (error) {
                    observer.error(error);
                    observer.complete();
                });
            })
                .catch(function (error) {
                observer.error(error);
                observer.complete();
            });
        });
    });
}
exports.getPaymentNonce = getPaymentNonce;
/**
 * GET BRAINTREE API KEY FROM SERVER
 **/
function getBraintreeApiKey(config) {
    var BRAINTREE_PAYMENTS_URL = "https://card-payments" + config.environment + ".cargosprintgroup.com/braintree";
    return rxjs_1.from(axios_1.default({
        method: 'GET',
        url: BRAINTREE_PAYMENTS_URL + "/clientToken",
        headers: { Authorization: "Bearer " + config.token },
    }))
        .pipe(operators_1.map(function (_a) {
        var data = _a.data;
        return data;
    }));
}
exports.getBraintreeApiKey = getBraintreeApiKey;
//# sourceMappingURL=braintree.js.map